import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const VerticalAlignmentCenter = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5 2H2.5C2.22386 2 2 2.22386 2 2.5V13.5C2 13.7761 2.22386 14 2.5 14H13.5C13.7761 14 14 13.7761 14 13.5V2.5C14 2.22386 13.7761 2 13.5 2ZM3 13V3H7.5V5.29289L6.85355 4.64645C6.65829 4.45118 6.34171 4.45118 6.14645 4.64645C5.95118 4.84171 5.95118 5.15829 6.14645 5.35355L7.64645 6.85355C7.84171 7.04882 8.15829 7.04882 8.35355 6.85355L9.85355 5.35355C10.0488 5.15829 10.0488 4.84171 9.85355 4.64645C9.65829 4.45118 9.34171 4.45118 9.14645 4.64645L8.5 5.29289V3H13V13H8.5V10.7071L9.14645 11.3536C9.34171 11.5488 9.65829 11.5488 9.85355 11.3536C10.0488 11.1583 10.0488 10.8417 9.85355 10.6464L8.35355 9.14645C8.25979 9.05268 8.13261 9 8 9C7.86739 9 7.74021 9.05268 7.64645 9.14645L6.14645 10.6464C5.95118 10.8417 5.95118 11.1583 6.14645 11.3536C6.34171 11.5488 6.65829 11.5488 6.85355 11.3536L7.5 10.7071V13H3ZM5 7.5C4.72386 7.5 4.5 7.72386 4.5 8C4.5 8.27614 4.72386 8.5 5 8.5L11 8.5C11.2761 8.5 11.5 8.27614 11.5 8C11.5 7.72386 11.2761 7.5 11 7.5L5 7.5Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default VerticalAlignmentCenter
